export default "__VITE_ASSET__D4VoBJzz__"